import { useMemo } from 'react';
import { useRouteContext } from '@lp/core/contexts/RouteContext';
import { UseLegWarningsParams } from '@lp/features/RoutePlanner/hooks/useLegWarnings';
import { useAircraftUtilizationContext } from '@lp/features/RoutePlanner/contexts/AircraftUtilizationContext';
import { getAircraftUtilizationWarningText, getLegAircraftId } from '@lp/features/RoutePlanner/utils';
import { RouteLegTypeEnum } from '@/api/apis/route';
import { CaseResourceType } from '@/api/apis/case';

const EMPTY_WARNINGS: string[] = [];

export type UseLegAircraftUtilizationWarningsParams = Pick<UseLegWarningsParams, 'leg'>;

export const useLegAircraftUtilizationWarnings = ({ leg }: UseLegAircraftUtilizationWarningsParams) => {
  const { utilizationsByAircraftId, mainLegIds } = useAircraftUtilizationContext();
  const { resourceById } = useRouteContext();

  return useMemo(() => {
    if (leg.legType !== RouteLegTypeEnum.TmdxJetAviaLeg) return EMPTY_WARNINGS;
    if (!mainLegIds.has(leg.id)) return EMPTY_WARNINGS;

    const aircraftId = getLegAircraftId(leg);
    const utilizations = aircraftId ? utilizationsByAircraftId.get(aircraftId) : undefined;

    if (!utilizations?.length) return EMPTY_WARNINGS;

    const tailNumber = aircraftId
      ? resourceById[CaseResourceType.Aircraft].get(aircraftId)?.data?.registration
      : undefined;

    return utilizations.map((u) => getAircraftUtilizationWarningText(u, tailNumber));
  }, [leg, mainLegIds, utilizationsByAircraftId, resourceById]);
};
